import DealerOrderListPanel from "./dealerOrderListPanel.container"

export default DealerOrderListPanel
